import Vue from 'vue'
function infoClient () {
  let OSS = require('ali-oss')
  let ossConfig = {
    region: 'oss-cn-beijing',
    // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。
    //   强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
    accessKeyId: 'LTAI4GC2Po1DXT5P8B5fV172',
    accessKeySecret: 'nKdrR3pxaJpc5aEI543WiYRjRcBOJ3',
    bucket: 'ag-sit-private'
  }
  return new OSS(ossConfig)
}
let tempCheckpointObj = {}
export default class OssSectionUpload {
  constructor (fileName, file, url) {
    this.fileName = fileName
    this.file = file
    this.url = url
    this.client = infoClient()
  }
  // 上传文件
  async multipartUpload (callback) {
    try {
      // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
      let that = this
      await this.client.multipartUpload(this.url, this.file, {
        partSize: 1000 * 1024,
        progress: function (p, checkpoint) {
          // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
          tempCheckpointObj[that.fileName] = checkpoint
          callback(p, that.fileName)
        },
        checkpoint: tempCheckpointObj[that.fileName] || 0,
        meta: { year: (new Date()).getFullYear(), people: Vue.prototype.$auth.user().userName }
      }).then(res => {
        Vue.prototype.$message.success('上传成功')
      }).catch(() => {
        if (this.client.isCancel()) {
          Vue.prototype.$message.error('上传失败')
        } else {
          Vue.prototype.$message.error('网络异常')
        }
      })
    } catch (e) {
      console.log(e)
    }
  }
  // 取消上传
  cancleUpload () {
    this.client.cancel()
  }
}
